var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import theme from '../../theme';
export var getDefaultStyles = function (_a) {
    var hasError = _a.hasError, hasWarning = _a.hasWarning;
    return ({
        control: function (base) { return (__assign(__assign({}, base), { borderRadius: theme.typography.border.radius.small, border: "solid " + theme.typography.border.width.xxxThin + " " + (hasError
                ? theme.colors.tfwErrorRed
                : hasWarning
                    ? theme.colors.tfwWarning
                    : theme.colors.tfwDefaultInputBorder), fontFamily: theme.typography.font.family.lato })); },
        dropdownIndicator: function (base) { return (__assign(__assign({}, base), { color: theme.colors.tfwBlack87, padding: "10px " + theme.spacing.small })); },
        indicatorSeparator: function () { return ({ display: 'none' }); },
        menu: function (base) { return (__assign(__assign({}, base), { borderRadius: theme.typography.border.radius.small, fontFamily: theme.typography.font.family.lato })); },
        placeholder: function (base) { return (__assign(__assign({}, base), { color: hasError ? theme.colors.tfwErrorRed : hasWarning ? theme.colors.tfwWarning : theme.colors.tfwBlack87, fontFamily: theme.typography.font.family.lato, fontSize: '0.9375rem' })); },
        valueContainer: function (base) { return (__assign(__assign({}, base), { fontSize: '0.9375rem' })); },
    });
};
